import * as React from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
// SelectBox.js

function SelectBox2({
  options = [],
  value,
  defaultValue = undefined,
  handleChange,
  disabled = false,
  placeholder,
}) {
  // value prop이 전달되면 controlled, 아니면 uncontrolled
  const isControlled = value !== undefined && value !== null;

  // defaultValue가 객체인 경우 value 속성 추출
  const normalizeDefault = (dv) => {
    if (dv && typeof dv === "object" && "value" in dv) {
      return dv.value;
    }
    return dv;
  };

  // 내부 상태 관리 (uncontrolled 모드용)
  const [internalValue, setInternalValue] = React.useState(() => {
    if (isControlled) return value;
    const normalized = normalizeDefault(defaultValue);
    return normalized ?? "";
  });

  // value나 defaultValue 변경 시 내부 상태 업데이트
  React.useEffect(() => {
    if (isControlled) {
      setInternalValue(value);
    } else {
      const normalized = normalizeDefault(defaultValue);
      if (normalized !== undefined && normalized !== null) {
        setInternalValue(normalized);
      }
    }
  }, [defaultValue, value, isControlled]);

  // 실제로 Select에 전달될 값
  const actualValue = isControlled ? value : internalValue;

  // 변경 핸들러
  const onChange = (e) => {
    if (!isControlled) {
      setInternalValue(e.target.value);
    }
    handleChange?.(e);
  };

  return (
    <Select
      labelId="select-box-type1"
      id="select-box-type1"
      className="comboBox-type1"
      value={actualValue}
      label="select"
      disabled={disabled}
      onChange={onChange}
      displayEmpty={!!placeholder}
      renderValue={(selected) => {
        if (
          placeholder &&
          (selected === "" || selected === null || selected === undefined)
        ) {
          return <span style={{ color: "#999" }}>{placeholder}</span>;
        }
        const selectedOption = options?.find((opt) => opt.value === selected);
        return selectedOption?.name || "";
      }}
      MenuProps={{
        style: { zIndex: 2000 },
        disableScrollLock: true,
        marginThreshold: null,
      }}
    >
      {options?.map((option, index) => (
        <MenuItem
          key={option.key ?? option.value ?? index}
          value={option.value}
          className="CRAZY"
        >
          {option.name}
        </MenuItem>
      ))}
    </Select>
  );
}
SelectBox2.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default React.memo(SelectBox2);
